import * as React from "react";
export const isVisible = (visibility) => {
    switch (visibility) {
        case "Initial":
        case "NotVisible":
            return false;
        case "Visible":
            return true;
    }
};
export const useVisible = (options) => {
    const [visibility, setVisibility] = React.useState("Initial");
    const [node, setNode] = React.useState(null);
    const observer = React.useRef();
    React.useEffect(() => {
        if (node !== null && node !== undefined) {
            if ("IntersectionObserver" in window) {
                // create new observer
                const newObserver = new IntersectionObserver((entries) => {
                    setVisibility(() => (entries[0]?.isIntersecting ? "Visible" : "NotVisible"));
                }, options);
                // observe node
                newObserver.observe(node);
                // disconnect previous observer
                observer.current?.disconnect();
                // set current observer to be new observer
                observer.current = newObserver;
                return () => {
                    newObserver.disconnect();
                };
            }
            else {
                setVisibility("Visible");
            }
        }
    }, [node, options]);
    return [setNode, visibility];
};
export const useVisibleOnce = (options) => {
    const [setNode, actualVisibility] = useVisible(options);
    const [visibility, setVisibility] = React.useState("Initial");
    React.useEffect(() => {
        setVisibility((current) => {
            switch (current) {
                case "Initial":
                case "NotVisible":
                    return actualVisibility;
                case "Visible":
                    return current;
            }
        });
    }, [actualVisibility]);
    return [setNode, visibility];
};
//# sourceMappingURL=Visibility.js.map